import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { getCurrentUser } from "../../../Api/auth.js";

function TopOne1() {

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const [role_id, seRole_id] = useState(null);
 
    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            seRole_id(getCurrentUserdata.user.role_id);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);



    return (
        <div className='remotefittingnewdesign  col-12 col-lg-4 '>
            <div className='row top-portion mx-4 d-flex justify-content-center'
                style={{ textAlign: 'center', borderRadius: '40px', backgroundColor: '#1e2025' }}>
                <div className='row heading-fitting-buttons d-flex justify-content-between align-items-center' >
                    {
                        role_id === 4 && <img className='col-12 text-white remote-text' style={{ textAlign: 'center' }} src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" />
                    }
                    {/* <img className='col-12 text-white remote-text' style={{ textAlign: 'center' }} src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" /> */}
                    <div className='col-12 d-flex justify-content-between align-items-center'>
                        <button className='col-5 btn-edit' onClick={goBack} >Exit</button>
                        <a href="tel:18052163991" class="text-white"><button class="col-6 btn-help">Help</button></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopOne1